import { useTheme, Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { alpha } from "@mui/system";

const CustomNoRowsOverlay = ({ message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {message || "It looks like you don't have any bookmarks yet!"}
      </Typography>
    </Box>
  );
};

const CollectionTableComponent = ({
  apiRef,
  rows,
  columns,
  handleColumnResize,
  visibilityModel,
  handleVisibilityChange,
  getRowId,
  getRowClassName,
  onRowClick,
  showCustomEmptyMessage = false,
  loading = true,
  noRowsMessage,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ height: loading ? 500 : "auto", width: "100%" }}>
    <DataGrid
      apiRef={apiRef}
      disableColumnMenu={false}
      rows={rows}
      columns={columns}
      pageSize={5}
      sx={{
        border: "none",
        overflow: "hidden",
        width: "100%",
        "& .MuiDataGrid-cell:focus-within": {
          backgroundColor: "transparent",
          outline: "none",
        },
        "& .MuiDataGrid-row.Mui-selected": {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.text.primary,
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.text.primary,
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.text.primary,
        },
        "& .MuiDataGrid-row.sooth-misinformation-row": {
          backgroundColor: alpha(theme.palette.warning.light, 0.25),
        },
      }}
      onColumnWidthChange={handleColumnResize}
      columnVisibilityModel={visibilityModel}
      onColumnVisibilityModelChange={handleVisibilityChange}
      getRowId={getRowId}
      getRowClassName={getRowClassName}
      initialState={{
        sorting: {
          sortModel: [{ field: "createdDateTime_dtm", sort: "desc" }],
        },
      }}
      onRowClick={onRowClick}
      slots={showCustomEmptyMessage ? {
        noRowsOverlay: CustomNoRowsOverlay,
      } : undefined}
      slotProps={{
        ...(showCustomEmptyMessage ? { noRowsOverlay: { message: noRowsMessage } } : {}),
        loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'skeleton',
        },
      }}
      loading={loading}
    />
    </Box>
  );
};

export default CollectionTableComponent;